import { UserData } from '@ypp-portal/models/user/userData';

export enum Chapter {
  Westchester = 'Westchester, NY',
  Katy = 'Katy, TX',
  Houston = 'Houston, TX',
  Dallas = 'Dallas, TX',
  Fairfield = 'Fairfield, CT',
  Boston = 'Boston, MA',
  Vancouver = 'Vancouver, Canada',
  CookCounty = 'Cook County, IL',
  Seoul = 'Seoul, South Korea',
  Tokyo = 'Tokyo, Japan',
  BergenCounty = 'Bergen County, NJ',
}

export type InstructorData = UserData & {
  bio: string;
  workshopAttended: boolean;
  static: {
    chapter: Chapter;
    classOf: number;
  };
};
